import { Button, Form, Offcanvas } from "react-bootstrap";
import { useEffect, useState } from "react";
import { userServices } from "../../APIServices/userServices";

const UpdateUser = ({ Show, Hide, Title, getUsers, userData }) => {
  const [loader, setLoader] = useState(false);
  const [name, setName] = useState("");

  const updateUserProfile = async () => {
    setLoader(true);
    const usersData = {
      fullName: name,
      userId: userData?.userId,
    };
    const data = await userServices.updateUserProfile(usersData);
    if (data?.statusCode === 200) {
      setName("");
      getUsers();
      Hide();
    }
    setLoader(false);
  };

  useEffect(() => {
    if (userData) {
      setName(userData?.name)
    }
  }, [userData]);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className="bg-light p-3 border-bottom">
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Name
          </Form.Label>
          <Form.Control
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Name"
            style={{ fontSize: 12 }}
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className="text-end p-2 border-top bg-light">
        <Button
          disabled={!name || loader}
          onClick={updateUserProfile}
          variant="outline-primary"
          style={{ fontSize: 13 }}
          className="rounded-2 py-1 px-3"
        >
          {loader ? "Updating..." : Title}
        </Button>
      </div>
    </Offcanvas>
  );
};

export default UpdateUser;